import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import * as BeMaccaferriStoreHelper from '../../../api/store/BeMaccaferriStoreHelper';
import { endpointMacra1 } from '../../pages';
import { DataRow } from '../Table/ITable';
import Table from '../Table/Table';
import { useCallback, useEffect, useState } from 'react';

interface IPanelTemplateProps {}

const PanelTemplate = (props: IPanelTemplateProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [templates, setTemplates] = useState<DataRow[]>([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const setTempaleDataRowAsync = useCallback(async (page?: number, newPerPage?: number, name?: string) => {
        let templateResponse = await BeMaccaferriStoreHelper.getCBPPreviewTemplatesAsync(page, newPerPage, name);
        let templateDataRow: DataRow[] = templateResponse.data.data.map(temp => ({ id: temp.id, name: temp.name, creationDate: temp.creationDate, isTemplate: true }));
        setTemplates(templateDataRow);
        setTotalRows(templateResponse.data.pagesCount * perPage);
    }, []);

    const fetchTemplates = async (page: number) => {
        setLoading(true);
        setTempaleDataRowAsync(page, perPage);
        setLoading(false);
    };

    const handlePageChange = (page: number) => {
        fetchTemplates(page);
    };

    const handlePerRowsChange = async (newPerPage: number, page: number) => {
        setLoading(true);
        setTempaleDataRowAsync(page, newPerPage);
        setPerPage(newPerPage);
        setLoading(false);
    };

    useEffect(() => {
        fetchTemplates(1);
    }, []);

    const handleSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setTempaleDataRowAsync(1, perPage, e.target.value);
    };

    const handleNew = () => {
        navigate(endpointMacra1.macra1BackofficeTemplate);
    };

    return (
        <div className='panel-container'>
            <div className='nosubmit d-flex justify-content-between mb-4'>
                <input className='nosubmit' type='search' placeholder='Search...' onChange={handleSearch} />
                <button type='button' onClick={handleNew}>
                    {t('backoffice_newTemplate')}
                </button>
            </div>

            <Table data={templates} progressPending={loading} pagination paginationServer paginationTotalRows={totalRows} onChangeRowsPerPage={handlePerRowsChange} onChangePage={handlePageChange} />
        </div>
    );
};

export default PanelTemplate;
